import { SearchResponse } from '@algolia/client-search';
import { FormattedFacet } from '~/types/facets';
import { Locale } from '~/types/locale';
import { AlgoliaResource } from '~/types/resource';

export type FacetKey =
  | `learning-area-${Locale}.lvl0`
  | `year-level-${Locale}.lvl0`
  | `resource-type-${Locale}.lvl0`
  | 'resource-availability.lvl0'
  | 'file-format.lvl0'
  | 'filter-attribute'
  | 'filter-resource-type.lvl0'
  | 'filter-resource-type.lvl1'
  | 'filter-learning-area.lvl0'
  | 'filter-learning-area.lvl1'
  | 'filter-price'
  | 'filter-format'
  | 'postTypeTitle';
export const isFacetKey = (key: string): key is FacetKey => {
  return (
    !!key.match(/learning-area-(au|gb|us).lvl0/) ||
    !!key.match(/year-level-(au|gb|us).lvl0/) ||
    !!key.match(/resource-type-(au|gb|us).lvl0/) ||
    key === 'resource-availability.lvl0' ||
    key === 'file-format.lvl0' ||
    key === 'postTypeTitle' ||
    key === 'filter-attribute' ||
    key === 'filter-resource-type.lvl0' ||
    key === 'filter-resource-type.lvl1' ||
    key === 'filter-learning-area.lvl0' ||
    key === 'filter-learning-area.lvl1' ||
    key === 'filter-price' ||
    key === 'filter-format'
  );
};

export type Filters = { [key in string]: string[] };
export type Facets = SearchResponse['facets'];
export type SearchResponseWithFacets = SearchResponse<AlgoliaResource> & {
  formattedFacets: FormattedFacet[];
};
